import { _ as _getMapData } from "./auth-service-tools1333.js";
var getMapData = _getMapData;

function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

var _mapCacheHas = mapCacheHas;
export { _mapCacheHas as _ };